import { render, staticRenderFns } from "./Mercado.vue?vue&type=template&id=68ea23f0&scoped=true"
import script from "./Mercado.vue?vue&type=script&lang=js"
export * from "./Mercado.vue?vue&type=script&lang=js"
import style0 from "./Mercado.vue?vue&type=style&index=0&id=68ea23f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea23f0",
  null
  
)

export default component.exports